import { type RefObject, useEffect, useState } from 'react'

import { HEADER_ELEMENT_ID } from '../constant'

export function useStickyBelowHeader(ref: RefObject<HTMLElement | null>) {
    const [offsetPx, setOffsetPx] = useState(0)
    const [isStuck, setIsStuck] = useState(false)

    useEffect(() => {
        const element = ref.current
        if (!element) return

        let frameId: number
        let lastOffsetPx = -1
        let lastIsStuck = false

        const tick = () => {
            const header = document.getElementById(HEADER_ELEMENT_ID)
            const headerOffset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0
            const stuck = element.getBoundingClientRect().top <= headerOffset

            if (headerOffset !== lastOffsetPx) {
                lastOffsetPx = headerOffset
                setOffsetPx(headerOffset)
            }
            if (stuck !== lastIsStuck) {
                lastIsStuck = stuck
                setIsStuck(stuck)
            }

            frameId = requestAnimationFrame(tick)
        }

        frameId = requestAnimationFrame(tick)

        return () => cancelAnimationFrame(frameId)
    }, [ref])

    return { isStuck, offsetPx }
}
